import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Avatar,
  Badge,
} from "@mui/material";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import logo from "../imgs/logo192.png";
import { auth, db } from "../firebase";
import { collection, query, where, onSnapshot, doc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

function Header() {
  const [unreadCount, setUnreadCount] = useState(0);
  const [userPhoto, setUserPhoto] = useState("");
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();

  // Listen for auth state and load user profile photo
  useEffect(() => {
    let unsubUser = null;
    const unsubAuth = auth.onAuthStateChanged((user) => {
      if (!user) return;
      setUserId(user.uid);
      unsubUser = onSnapshot(doc(db, "users", user.uid), (snap) => {
        if (snap.exists()) setUserPhoto(snap.data().profileImageUrl || snap.data().photoURL || "");
      });
    });
    return () => { unsubAuth(); unsubUser?.(); };
  }, []);

  // Listen for unread notifications
  useEffect(() => {
    if (!userId) return;
    const q = query(
      collection(db, "notifications"),
      where("userId", "==", userId),
      where("read", "==", false)
    );
    const unsub = onSnapshot(q, (snap) => setUnreadCount(snap.size));
    return () => unsub();
  }, [userId]);

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        background: "linear-gradient(135deg, #1565C0 0%, #1976d2 55%, #42A5F5 100%)",
        borderBottom: "none",
      }}
    >
      <Toolbar sx={{ minHeight: 64, px: 2 }}>
        {/* Branding */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, flex: 1 }}>
          <Box
            component="img"
            src={logo}
            alt="Chatio"
            sx={{
              width: 40,
              height: 40,
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
              bgcolor: "white",
              p: "3px",
            }}
          />
          <Box>
            <Typography
              variant="h6"
              fontWeight="800"
              sx={{
                color: "white",
                letterSpacing: "0.5px",
                lineHeight: 1.1,
                fontSize: "1.25rem",
              }}
            >
              Chatio
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "rgba(255,255,255,0.80)", fontSize: "0.68rem", letterSpacing: "0.3px" }}
            >
              Mensajes &amp; Noticias
            </Typography>
          </Box>
        </Box>

        {/* Actions */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <IconButton
            onClick={() => navigate("/notifications")}
            sx={{ color: "white", "&:hover": { bgcolor: "rgba(255,255,255,0.15)" } }}
          >
            <Badge
              badgeContent={unreadCount > 0 ? unreadCount : null}
              color="error"
              max={9}
              sx={{ "& .MuiBadge-badge": { fontSize: "0.65rem", minWidth: 16, height: 16 } }}
            >
              <NotificationsOutlinedIcon />
            </Badge>
          </IconButton>

          <IconButton
            onClick={() => userId && navigate(`/perfil/${userId}`)}
            sx={{ p: 0.5, "&:hover": { bgcolor: "rgba(255,255,255,0.15)", borderRadius: "50%" } }}
          >
            <Avatar
              src={userPhoto}
              sx={{
                width: 34,
                height: 34,
                border: "2px solid rgba(255,255,255,0.7)",
                fontSize: "0.9rem",
                bgcolor: "#1565C0",
              }}
            >
              {!userPhoto && "👤"}
            </Avatar>
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;

